
<div class="" *ngIf="tieneHorasExtras">
  <p-divider align="left" type="dashed">
    <b>Historial de horas extras y días libres</b>
</p-divider>

<div class="col-12 container-horasExtras" >
  <div class="horasExtras">
    <h3 class="font-semibold mb-0" style="font-family: 'Poppins', sans-serif;">Horas Extras</h3>
    <table>
        <thead>
          <th>Fecha</th>
          <th>Horas</th>
          <th>Descripción</th>
        </thead>

      <tr *ngFor="let horaExtra of horasExtrasPeriodo">
        <td>{{ horaExtra.fecha | date : "dd/MM/yyyy" }}</td>
        <td>{{ horaExtra.horasExtras }} horas</td>
        <td>{{ horaExtra.descripcion }}</td>
      </tr>
    </table>
      <p class="text-secondary font-semibold">Horas Extras Totales: {{ horasExtrasTotales | number : "1.2-2" }}</p>
  </div>
    &nbsp;
    <div class="horasExtras">
      <h3 class="font-semibold mb-0" style="font-family: 'Poppins', sans-serif;">Días Libres</h3>
      <table>
        <thead>
          <th>Fecha</th>
          <th>Horas</th>
          <th>Descripción</th>
        </thead>
        <tr *ngFor="let horaLibre of horasLibresPeriodo">
          <td>{{ horaLibre.fecha | date : "dd/MM/yyyy" }}</td>
          <td>{{ horaLibre.horas }} horas</td>
          <td>{{ horaLibre.descripcion }}</td>
        </tr>
      </table>
      <p class="text-secondary font-semibold"> Horas Días Libres: {{ horasLibresTotales | number : "1.2-2" }}</p>
    </div>
    &nbsp;
    <h3 class="font-semibold mb-0" style="font-family: 'Poppins', sans-serif;">Horas Extra Liquidación: {{ horasExtrasTotales - horasLibresTotales < 0 ? 0 : horasExtrasTotales - horasLibresTotales | number : "1.2-2" }}</h3>
</div>
</div>
